module.exports = __webpack_public_path__ + "img/check.ae0d54be.png";